import { EcommerceError, GenericError } from '../../../domain/models/error.models';

import { isDefined } from '@frontend/common/utils';

/**
 * Create ecommerce error
 *
 * @param error Error
 *
 * @returns Ecommerce error
 */
export function createEcommerceError(error: GenericError): EcommerceError {
    if (isDefined(error.error?.description) && isDefined(error.error?.key)) {
        return mapGenericErrorToEcommerceError(error);
    }

    return mapHttpErrorToEcommerceError(error);
}

/**
 * Map generic error to ecommerce error
 *
 * @param error Error
 *
 * @returns Ecommerce error
 */

export function mapGenericErrorToEcommerceError(error: GenericError): EcommerceError {
    return {
        message: error.error.description,
        key: error.error.key,
        httpStatus: error.status,
        originalError: error,
    };
}

/**
 * Map HTTP error to ecommerce error
 *
 * @param error Error
 *
 * @returns Ecommerce error
 */
export function mapHttpErrorToEcommerceError(error: GenericError): EcommerceError {
    const defaultMessageMap = {
        400: { message: 'Bad request', key: 'HTTP_BAD_REQUEST' },
        403: { message: 'Insufficient permission', key: 'HTTP_FORBIDDEN' },
        404: { message: 'Requested resource not found', key: 'HTTP_NOT_FOUND' },
        413: { message: 'Payload Too Large', key: 'HTTP_PAYLOAD_TOO_LARGE' },
        500: { message: 'Internal server error', key: 'HTTP_INTERNAL_SERVER_ERROR' },
    };

    const { message, key } = defaultMessageMap[error.status] || {
        message: 'Unspecified HTTP error',
        key: 'GENERAL_HTTP_ERROR',
    };

    return {
        message,
        key,
        httpStatus: error.status,
        originalError: typeof error === 'string' ? null : error,
    };
}
